import React from 'react'
import PropTypes from 'prop-types'

export default class Delay extends React.Component {
  static displayName = 'Delay'

  static propTypes = {
    initial: PropTypes.number,
    children: PropTypes.any,
    value: PropTypes.number,
    period: PropTypes.number
  }

  constructor (props) {
    super(props)

    this.state = {
      value: this.props.initial
    }
  }

  static getDerivedStateFromProps (props, state) {
    return (props.value === state.value) ? null : { value: props.value }
  }

  componentDidMount = () => {
    const setProps = () => this.setState((prevState, props) => {
      const { value } = props

      // update state only if the value has changed
      return (prevState.value === value) ? null : { value }
    })

    return setTimeout(setProps, this.props.period)
  }

  render = () => {
    return this.props.children(this.state.value)
  }
}
